import React from "react"
import { injectIntl } from "gatsby-plugin-intl"
import ServiceTerminal from "@tmu/components/terminal/ServiceTerminal"

const Terminal = () => <ServiceTerminal />

export default injectIntl(Terminal)
